import { NoticeFactory } from '@b2b/common/factories/notice';
import { PaymentService } from '@b2b/common/services';
import { LocationService, LocationServiceModule } from '@b2b/common/services/address/location.service';
import { ApiService } from '@b2b/common/services/api/types';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ACMEValidator, ValidateService } from '@b2b/common/services/validate';
import { CountryMetadata, StateMetadata } from '@b2b/types/core';
import { TODO } from '@b2b/types/core/utils';
import angular, { IScope, ITimeoutService } from 'angular';

AddressCreateDirective.$inject = [];

function AddressCreateDirective() {
  AddressCreateController.$inject = [
    '$scope',
    '$timeout',
    'ApiService',
    'ValidateService',
    'NoticeFactory',
    'ThemesHelperService',
    'PaymentProcessorService',
    'uuid2',
    'HelpersService',
    'PaymentService',
    'LocationService',
  ];

  function AddressCreateController(
    $scope: IScope & {
      addressCreate: TODO;
      watchModel: TODO;
      addressChanged: TODO;
      modelOutput: TODO;
      model: TODO;
      addressId: TODO;
      title: TODO;
      preventValidate: TODO;
      layout: TODO;
      organizationId: TODO;
      hideErrors: TODO;
      useValidationPreferences: TODO;
      ignoreValidationPreferences: TODO;
      preventSave: TODO;
    },
    $timeout: ITimeoutService,
    ApiService: ApiService,
    ValidateService: ValidateService,
    NoticeFactory: NoticeFactory,
    ThemesHelperService: ThemesHelperService,
    PaymentProcessorService: TODO,
    uuid2: TODO,
    HelpersService: TODO,
    PaymentService: PaymentService,
    LocationService: LocationService
  ) {
    const ctrl = {
      isSubmitted: false,
      showStatesList: true,

      idSuffix: uuid2.newuuid(),

      loading: false,

      base: {
        country: '',
        streetAddress1: '',
        streetAddress2: '',
        city: '',
        state: null,
        zipCode: '',
        otherState: '',
        otherCountry: '',
        type: 'secondary',
        isPrimary: false,
      },

      model: {} as TODO,

      countries: [] as CountryMetadata[],

      id: false,

      title: 'New Address',
      errors: [] as { message: string }[],
      states: [] as StateMetadata[],
      provinces: [],

      selectedCountryChanged: false,
      selectedCountry: false as TODO | false | null,
      selectedState: false as TODO | false | null,

      notice: new NoticeFactory(),
      preferences: ThemesHelperService.getCCValidationSettings(),

      init: function () {
        ctrl.setModel(ctrl.base);

        if ($scope.addressId) {
          ctrl.id = $scope.addressId;
        }

        if ($scope.model && $scope.model.id) {
          ctrl.model = angular.copy($scope.model);
          ctrl.title = 'Edit Address';
        }

        if ($scope.title) {
          ctrl.title = $scope.title;
        }

        ctrl.getCountries();
        ctrl.setModelOutput();

        $scope.$on('AddressCreate::Check', ctrl.onAddressCreateCheck);
        $scope.$on('AddressCreate::Update', ctrl.onAddressCreateUpdate);
        $scope.$on('AddressCreate::Process', ctrl.onAddressCreateProcess);
        $scope.$on('AddressCreate::Set', ctrl.onAddressCreateSet);
        $scope.$on('AddressCreate::Reset', ctrl.onAddressCreateReset);

        $scope.$watch('addressCreate.model.country', function () {
          ctrl.getStates();
        });

        $scope.$on('$destroy', $scope.$watch('sameAddress', ctrl.onSameAddressUpdate));

        if ($scope.watchModel) {
          $scope.$on('$destroy', $scope.$watchCollection('model', ctrl.onModelUpdate));
        }

        $scope.$on(
          '$destroy',
          $scope.$watch(
            'addressCreate.model',
            function (newValue, oldValue) {
              ctrl.onModelUpdate(newValue, oldValue);

              $scope.addressChanged({ $event: ctrl.model });
            },
            true
          )
        );
      },

      setModelOutput: function () {
        if ($scope.modelOutput) {
          $scope.modelOutput = ctrl.model;
        }
      },

      setModel: function (data) {
        Object.assign(ctrl.model, data);
      },

      setModelWithId: function (data) {
        if (!data.id || (ctrl.id && ctrl.id === data.id)) {
          ctrl.setModel(data.model);
        }
      },

      resetModel: function () {
        ctrl.setModel(ctrl.base);

        if (!ctrl.countries.length && !ctrl.loading) {
          ctrl.getCountries();
        } else {
          ctrl.setDefaultCountry();
        }
      },

      resetModelWithId: function (data) {
        if (!data.id || (ctrl.id && ctrl.id === data.id)) {
          ctrl.resetModel();
        }
      },

      getB2BValidationPreferences: function (): string | boolean {
        let validation = false;

        if (ctrl.preferences.hasOwnProperty('b2bValidation')) {
          validation = ctrl.preferences.b2bValidation.toLowerCase();
        }

        return validation;
      },

      getDefaultCountry: function () {
        const useValidation = ctrl.getB2BValidationPreferences() !== 'none'; // TODO: Should this be checking against 'address'?
        const useB2BValidationPreferences =
          ctrl.ignoreValidationPreferences() || (ctrl.useValidationPreferences() && useValidation);

        if (useB2BValidationPreferences) {
          return ThemesHelperService.getCompany('country') || 'United States';
        }

        return '';
      },

      setDefaultCountry: function () {
        const defaultCountry = ctrl.getDefaultCountry();

        if (defaultCountry) {
          ctrl.model.country = defaultCountry;
          const found = ctrl.findCountry(ctrl.model.country);
          ctrl.selectedCountry = found ? found.country : false;
        }
      },

      setDefaultState: function (state) {
        let validation: string | boolean = false;

        if (ctrl.preferences.hasOwnProperty('b2bValidation')) {
          validation = ctrl.preferences.b2bValidation.toLowerCase();
        }
        if (ctrl.ignoreValidationPreferences() || (ctrl.useValidationPreferences() && validation === 'address')) {
          ctrl.model.state = state.name;
          ctrl.selectedState = state;
        }
      },

      isValid: function (field) {
        let r = true;

        // Check if submitted or bypass validation on command
        if (ctrl.isSubmitted && !$scope.preventValidate && ctrl.checkFieldValidation(field)) {
          r = ValidateService.validate([
            {
              len: {
                value: ctrl.model[field],
              },
            },
          ] as ACMEValidator[]);
        }

        return r;
      },

      isOtherStateValid: function (field) {
        let r = true;

        // Check if submitted or bypass validation on command
        if (
          ctrl.isSubmitted &&
          !$scope.preventValidate &&
          ctrl.checkFieldValidation(field) &&
          (ctrl.isCountry('Canada') || ctrl.isCountry('United States'))
        ) {
          r = ValidateService.validate([
            {
              len: {
                value: ctrl.model['otherState'],
              },
            },
          ] as ACMEValidator[]);
        }

        return r;
      },

      isZipcodeValid: function () {
        let r = true;

        if (ctrl.isCountry('Canada')) {
          // Check if submitted or bypass validation on command
          if (ctrl.isSubmitted && !$scope.preventValidate) {
            r = ValidateService.validate([
              {
                zipcode: {
                  message: PaymentProcessorService.fields.errors.zip,
                  test: () => {
                    return {
                      value: ctrl.model.zipCode || '',
                      country: ctrl.model.country || '',
                      required: ctrl.checkFieldValidation('zipCode'),
                    };
                  },
                },
              },
            ] as ACMEValidator[]);
          }
        } else {
          r = ctrl.isValid('zipCode');
        }

        return r;
      },

      getZipErrorMessage: function () {
        let r = '';
        const country = ctrl.model.country || '';

        switch (country.toLowerCase()) {
          case 'canada':
            r = 'Invalid. Use uppercase and a space (e.g. A1A 1A1)';
            break;
          default:
            r = 'Please enter a valid Zip/Postal Code';
        }

        return r;
      },

      hasErrors: function () {
        return !$scope.hideErrors && ctrl.errors instanceof Array && ctrl.errors.length > 0;
      },

      isValidState: function () {
        ctrl.showStatesList = ctrl.hasStates();
      },

      toggleStatesList: function () {
        ctrl.showStatesList = !ctrl.showStatesList;
      },

      useValidationPreferences: function () {
        return HelpersService.coerceBooleanProperty($scope.useValidationPreferences);
      },

      ignoreValidationPreferences: function () {
        return HelpersService.coerceBooleanProperty($scope.ignoreValidationPreferences);
      },

      checkFieldProperties: function (property, field) {
        let r = false;

        if (ctrl.useValidationPreferences()) {
          if (property === 'address') {
            switch (field) {
              case 'address-label-' + ctrl.idSuffix:
              /* falls through */
              case 'address-create-country-select-' + ctrl.idSuffix:
              /* falls through */
              case 'address-create-country-input-' + ctrl.idSuffix:
              /* falls through */
              case 'address-create-state-select-' + ctrl.idSuffix:
              /* falls through */
              case 'address-create-state-input-' + ctrl.idSuffix:
              /* falls through */
              case 'country-' + ctrl.idSuffix:
              /* falls through */
              case 'otherCountry-' + ctrl.idSuffix:
              /* falls through */
              case 'streetAddress1-' + ctrl.idSuffix:
              /* falls through */
              case 'streetAddress2-' + ctrl.idSuffix:
              /* falls through */
              case 'address1-' + ctrl.idSuffix:
              /* falls through */
              case 'address2-' + ctrl.idSuffix:
              /* falls through */
              case 'city-' + ctrl.idSuffix:
              /* falls through */
              case 'state-' + ctrl.idSuffix:
              /* falls through */
              case 'otherState-' + ctrl.idSuffix:
              /* falls through */
              case 'zip-' + ctrl.idSuffix:
              /* falls through */
              case 'zipCode-' + ctrl.idSuffix:
                r = true;
            }
          } else if (property === 'zipcode') {
            switch (field) {
              case 'address-label-' + ctrl.idSuffix:
              case 'address-create-country-select-' + ctrl.idSuffix:
              case 'address-create-country-input-' + ctrl.idSuffix:
              case 'country-' + ctrl.idSuffix:
              case 'otherCountry-' + ctrl.idSuffix:
              case 'zip-' + ctrl.idSuffix:
              case 'zipCode-' + ctrl.idSuffix:
                r = true;
                break;
            }
          } else if (property === 'none') {
            if (field === 'none-' + ctrl.idSuffix) {
              r = true;
            }
          }
        } else {
          // None must always return the inverse of the other fields
          // because it uses ng-hide
          r = field !== 'none-' + ctrl.idSuffix;
        }

        return r;
      },

      checkFieldValidation: function (name) {
        let validation = 'none';

        if (ctrl.preferences.hasOwnProperty('b2bValidation')) {
          validation = ctrl.preferences.b2bValidation.toLowerCase();
        }

        return ctrl.checkFieldProperties(validation, name + '-' + ctrl.idSuffix);
      },

      checkFieldDisplay: function (name) {
        let display = 'zipcode';

        if (ctrl.preferences.hasOwnProperty('b2bDisplay')) {
          display = ctrl.preferences.b2bDisplay.toLowerCase();
        }

        return ctrl.checkFieldProperties(display, name + '-' + ctrl.idSuffix);
      },

      checkRequired: function (field) {
        return !!ctrl.ignoreValidationPreferences() || ctrl.checkFieldValidation(field);
      },

      checkRequiredOtherState: function (field) {
        return ctrl.isCountry('Canada') || ctrl.isCountry('United States');
      },

      getValidators: function () {
        let validators: ACMEValidator[] = [];

        const tests = {
          // Full address Tests
          address: [
            {
              field: PaymentProcessorService.fields.streetAddress1 + '-' + ctrl.idSuffix,
              len: {
                message: PaymentProcessorService.fields.errors.streetAddress1,
                test: { value: ctrl.model.streetAddress1 },
              },
            },
            {
              field: PaymentProcessorService.fields.city + '-' + ctrl.idSuffix,
              len: { message: PaymentProcessorService.fields.errors.city, test: { value: ctrl.model.city } },
            },
          ] as ACMEValidator[],
          zipcode: [] as ACMEValidator[],
          none: [] as ACMEValidator[],
        };

        if (ctrl.isCountry('Canada')) {
          tests.address.push({
            field: PaymentProcessorService.fields.zip + '-' + ctrl.idSuffix,
            zipcode: {
              message: PaymentProcessorService.fields.errors.zip,
              test: function () {
                return {
                  value: ctrl.model.zipCode || '',
                  country: ctrl.model.country || '',
                  required: ctrl.checkFieldValidation('zipCode'),
                };
              },
            },
          });

          tests.zipcode.push({
            field: PaymentProcessorService.fields.zip + '-' + ctrl.idSuffix,
            zipcode: {
              message: PaymentProcessorService.fields.errors.zip,
              test: function () {
                return {
                  value: ctrl.model.zipCode || '',
                  country: ctrl.model.country || '',
                  required: ctrl.checkFieldValidation('zipCode'),
                };
              },
            },
          });

          tests.none.push({
            field: PaymentProcessorService.fields.zip + '-' + ctrl.idSuffix,
            zipcode: {
              message: PaymentProcessorService.fields.errors.zip,
              test: function () {
                return {
                  value: ctrl.model.zipCode || '',
                  country: ctrl.model.country || '',
                  required: ctrl.checkFieldValidation('zipCode'),
                };
              },
            },
          });
        } else {
          tests.address.push({
            field: PaymentProcessorService.fields.zip + '-' + ctrl.idSuffix,
            len: { message: PaymentProcessorService.fields.errors.zip, test: { value: ctrl.model.zipCode } },
          });
          tests.zipcode.push({
            field: PaymentProcessorService.fields.zip + '-' + ctrl.idSuffix,
            len: { message: PaymentProcessorService.fields.errors.zip, test: { value: ctrl.model.zipCode } },
          });
        }

        if (ctrl.isCountry('Other')) {
          // Test other country if Other is selected
          tests.address.push({
            field: PaymentProcessorService.fields.country + '-' + ctrl.idSuffix,
            len: { message: PaymentProcessorService.fields.errors.country, test: { value: ctrl.model.otherCountry } },
          });
        } else {
          // Test country field if not Other
          tests.address.push({
            field: PaymentProcessorService.fields.country + '-' + ctrl.idSuffix,
            len: { message: PaymentProcessorService.fields.errors.country, test: { value: ctrl.model.country } },
          });
        }

        if (ctrl.showStatesList) {
          ctrl.model.otherState = '';
        } else {
          ctrl.model.state = ctrl.model.otherState;
        }

        // Since we decide to set the state later we add this test here
        if (ctrl.isCountry('Canada') || ctrl.isCountry('United States')) {
          tests.address.push({
            field: PaymentProcessorService.fields.state + '-' + ctrl.idSuffix,
            len: { message: PaymentProcessorService.fields.errors.state, test: { value: ctrl.model.state } },
          });
        }

        if (ctrl.useValidationPreferences()) {
          // Use preferences for display and validation
          if (ctrl.preferences.hasOwnProperty('b2bValidation')) {
            validators = tests[ctrl.preferences['b2bValidation'].toLowerCase()];
          } else {
            validators = [];
          }
        } else if (!ctrl.ignoreValidationPreferences()) {
          // no validation as address is not required [See ENG-515]
          validators = tests.none;
        } else {
          validators = tests.address;
        }

        return validators;
      },

      getZipHint: function () {
        let r = '';

        if (ctrl.model && ctrl.model.country) {
          switch (ctrl.model.country.toLowerCase()) {
            case 'canada':
              r = '(e.g. A1A 1A1)';
              break;
            default:
              r = '';
          }
        }

        return r;
      },

      complete: function (select?: TODO) {
        ctrl.isSubmitted = true;

        if (ValidateService.validate(ctrl.getValidators())) {
          // Only overwrite this value if country is Other
          if (ctrl.isCountry('Other')) {
            ctrl.model.country = ctrl.model.otherCountry;
          } else {
            ctrl.model.otherCountry = '';
          }

          if (!$scope.preventSave) {
            if (ctrl.model.id) {
              ctrl.update(select);
            } else {
              ctrl.create(select);
            }
          } else {
            ctrl.errors = [];
            ctrl.isSubmitted = false;
            $scope.$emit('AddressCreate::Complete', { select: select, address: ctrl.model });
          }
        } else {
          ctrl.errors = [{ message: 'Please correct the errors below.' }];
          $scope.$emit('AddressCreate::Error', { errors: ValidateService.getErrorHash() });
        }
      },

      update: function (select) {
        ApiService.organizations.addresses
          .update({
            organizationId: $scope.organizationId,
            address: ctrl.model,
          })
          .then(function (response) {
            ctrl.success.complete(response);
            $scope.$emit('AddressCreate::Complete', { select: select, address: ctrl.model });
          })
          .catch(ctrl.error.complete);
      },

      create: function (select) {
        ApiService.organizations.addresses
          .create({
            organizationId: $scope.organizationId,
            address: ctrl.model,
          })
          .then(function (response) {
            ctrl.success.complete(response);
            $scope.$emit('AddressCreate::Complete', { select: select, address: ctrl.model });
          })
          .catch(ctrl.error.complete);
      },

      close: function () {
        $scope.$emit('AddressCreate::Close');
      },

      hasState: function () {
        if (!ctrl.isCountry(ctrl.countries[2].name)) {
          // Not Other
          return ctrl.findState(ctrl.model.state);
        }

        return false;
      },

      findState: function (name: string) {
        let r: { state: StateMetadata; index: number } | null = null;

        for (let i = 0, ii = ctrl.states.length; i < ii; i++) {
          // Uses abbreviation instead of alpha2Code for states call
          if (ctrl.states[i].name === name || ctrl.states[i].abbreviation === name) {
            r = {
              state: ctrl.states[i],
              index: i,
            };
            break;
          }
        }

        return r;
      },

      isCountry: function (name) {
        return ctrl.model.country === name;
      },

      hasStates: function () {
        return ctrl.isCountry('United States') || ctrl.isCountry('Canada');
      },

      findCountry: function (name: string) {
        let r: { country: CountryMetadata; index: number } | false = false;

        for (let i = 0, ii = ctrl.countries.length; i < ii; i++) {
          if (ctrl.countries[i].name === name || ctrl.countries[i].alpha2Code === name) {
            r = {
              country: ctrl.countries[i],
              index: i,
            };
            break;
          }
        }

        return r;
      },

      getCountries: function () {
        ctrl.loading = true;
        LocationService.fetchCountriesMetadata()
          .then((response) => ctrl.success.getCountries(response))
          .catch((response) => ctrl.error.getCountries(response));
      },

      getStates: function () {
        const found = ctrl.findCountry(ctrl.model.country);

        if (found) {
          LocationService.fetchStatesMetadata({ country: found.country.alpha2Code.toLowerCase() })
            .then((response) => ctrl.success.getStates(response))
            .catch((response) => ctrl.error.getStates(response));
        } else {
          ctrl.isValidState();
        }
      },

      setCountryToOther: function () {
        ctrl.selectedCountry = false;
        ctrl.model.otherCountry = ctrl.model.country;
        ctrl.model.country = 'Other';
      },

      setStateToOther: function (setOtherToEmpty) {
        ctrl.selectedState = null;

        if (ctrl.model.state.length) {
          ctrl.model.otherState = ctrl.model.state;
        } else {
          ctrl.model.otherState = null;
        }

        ctrl.model.state = null;
      },

      success: {
        init: function (response) {},
        complete: function (response) {
          ctrl.isSubmitted = false;
          ctrl.model = response.data.payload;
          // Copy for downstream use
          ctrl.model.addressId = ctrl.model.id;
          $scope.model = ctrl.model;
        },
        getStates: function (states: StateMetadata[]) {
          ctrl.states = states;

          ctrl.isValidState();
          ctrl.model.otherState = ctrl.model.state;

          const found = ctrl.findState(ctrl.model.state);

          if (found) {
            ctrl.selectedState = found.state;

            if (!$scope.layout) {
              ctrl.model.state = found.state.name;
            }
          } else if (!ctrl.states.length) {
            ctrl.setStateToOther(ctrl.selectedCountryChanged);
          }
          ctrl.selectedCountryChanged = false;
        },
        getCountries: function (countries: CountryMetadata[]) {
          const companyCountry = ThemesHelperService.getCompany('country');
          let companyCountryObj: CountryMetadata | undefined = undefined;
          let found;

          ctrl.countries = countries;

          if (!ctrl.countries.length) {
            ctrl.setCountryToOther();
          } else {
            ctrl.countries.forEach(function (item, index) {
              if (item.name === companyCountry) {
                companyCountryObj = ctrl.countries.splice(index, 1).shift();
              }
            });

            if (companyCountryObj) {
              ctrl.countries.unshift(companyCountryObj);
            }

            if (!ctrl.model.country) {
              ctrl.setDefaultCountry();
              if (ctrl.model.country) {
                found = ctrl.findCountry(ctrl.model.country);

                if (!found) {
                  ctrl.setCountryToOther();
                }
              }
            } else {
              //the country is set in the model, so pre-populate with that information
              found = ctrl.findCountry(ctrl.model.country);

              if (found) {
                ctrl.selectedCountry = found.country;
                if (!$scope.layout) {
                  ctrl.model.country = found.country.name;
                }
              } else {
                ctrl.setCountryToOther();
              }
            }
          }
          ctrl.loading = false;
          ctrl.getStates();
        },
      },

      error: {
        init: function (response) {},
        complete: function (response) {
          ctrl.errors = [{ message: response.data.error }];
          $scope.$emit('AddressCreate::Error', { errors: ctrl.errors });
        },

        getStates: function (response) {
          ctrl.selectedCountryChanged = false;
        },
        getCountries: function (response) {
          ctrl.loading = false;
        },
      },

      onAddressCreateProcess: function (e, data) {
        ctrl.complete();
      },

      onAddressCreateCheck: function (e, data) {
        if (!data || (data && !data.silent)) {
          ctrl.isSubmitted = true;
        }

        if (data && data.hasMembership) {
          ctrl.model = data;
        }

        Object.assign($scope.model, ctrl.model);

        /**
         * I wasn't able to repro consistently but there seems to be a race condition
         * causing `showStatesList` to be false and then `model.state` to be
         * overridden with an empty value from `otherState` under some circumstances.
         *
         * Since `isValidState` is a synchronous function it's safe to call it here to
         * update `showStatesList` and get the correct state on our billing contact info.
         *
         * @see ENG-12769
         */
        ctrl.isValidState();

        if (ctrl.showStatesList) {
          $scope.model.otherState = null;
        } else {
          $scope.model.state = ctrl.model.otherState;
        }

        // Only overwrite this value if country is Other
        if (ctrl.isCountry('Other')) {
          $scope.model.country = ctrl.model.otherCountry;
        } else {
          $scope.model.otherCountry = '';
        }

        if (!ValidateService.validate(ctrl.getValidators())) {
          $scope.$emit('AddressCreate::CheckError', { errors: ValidateService.getErrorHash() });
        } else {
          $scope.$emit('AddressCreate::CheckSuccess');
        }
      },

      onAddressCreateSet: function (e, data) {
        ctrl.setModelWithId(data);
      },

      onAddressCreateReset: function (e, data) {
        ctrl.resetModelWithId(data);
      },

      onAddressCreateUpdate: function (e, data) {
        ctrl.model = $scope.model;
      },

      onSelectedCountryUpdate: function (e, data) {
        ctrl.selectedCountryChanged = true;

        if (ctrl.selectedCountry) {
          ctrl.model.country = ctrl.selectedCountry.name;
        } else {
          if (!ctrl.countries.length) {
            ctrl.setCountryToOther();
          } else {
            ctrl.model.country = '';
          }
        }

        ctrl.getStates();
      },

      onSelectedStateUpdate: function (e, data) {
        if (ctrl.selectedState) {
          ctrl.model.state = ctrl.selectedState.name;
        } else {
          if (!ctrl.states.length) {
            ctrl.model.otherState = ctrl.model.state;
          } else {
            ctrl.model.state = '';
          }
        }
      },

      onSameAddressUpdate: function (newValue, oldValue) {
        if (newValue) {
          ctrl.setModel(newValue);
        } else {
          ctrl.resetModel();
        }
      },

      onModelUpdate: function (newValue, oldValue) {
        let found;
        let foundState;
        let countryCode = null;
        let stateCode = null;

        if (newValue) {
          Object.assign(
            ctrl.model,
            newValue,
            /**
             * We have to explicitly set the model properties because "other" type contacts
             * use an empty object for their address model.
             */
            {
              city: newValue.city,
              country: newValue.country,
              otherCountry: newValue.otherCountry,
              otherState: newValue.otherState,
              state: newValue.state,
              streetAddress1: newValue.streetAddress1,
              streetAddress2: newValue.streetAddress2,
              zipCode: newValue.zipCode,
            }
          );

          if (!ctrl.model.country) {
            ctrl.setDefaultCountry();
          }

          found = ctrl.findCountry(ctrl.model.country);

          if (found) {
            ctrl.selectedCountry = found.country;
            if (ctrl.selectedCountry) {
              foundState = ctrl.findState(ctrl.model.state);
              if (foundState) {
                ctrl.selectedState = foundState.state;

                if (!$scope.layout) {
                  ctrl.model.state = foundState.state.name;
                }
              } else if (!ctrl.model.state) {
                ctrl.selectedState = null;
              }
            }
          } else {
            ctrl.selectedCountry = null;
            ctrl.selectedState = null;
          }

          // secure checkout props
          stateCode = ctrl.selectedState && ctrl.selectedState.abbreviation ? ctrl.selectedState.abbreviation : '';
          countryCode =
            ctrl.selectedCountry && ctrl.selectedCountry.numericCode ? ctrl.selectedCountry.numericCode : '';

          PaymentService.setSecureCheckoutProps(
            Object.assign({}, ctrl.model, {
              state: stateCode,
              countryCode: countryCode,
            })
          );
        }
      },
    };

    $scope.addressCreate = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/address/create/create.tpl.html',
    scope: {
      model: '<',
      modelOutput: '=?',
      disabled: '=?',
      preventValidate: '=?',
      preventSave: '=?',
      sameAddress: '=?',
      useValidationPreferences: '@',
      ignoreValidationPreferences: '@',
      addressId: '@',
      title: '@',
      hideTitle: '@',
      hidePrimary: '@',
      hideErrors: '@',
      editName: '@',
      addSelect: '@',
      organizationId: '@',
      watchModel: '@',
      layout: '@',
      addressChanged: '&',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: AddressCreateController,
  };
}

export const AddressCreateDirectiveModule = angular
  .module('acme.common.directive.addressCreate', [
    'acme.common.service.api',
    'acme.common.service.validate',
    'acme.common.factory.notice',
    'acme.common.directive.notice',
    'acme.common.directive.combobox',
    'acme.common.service.themesHelper',
    'acme.common.service.paymentProcessor',
    'acme.common.service.payment',
    'acme.common.service.helpers',
    LocationServiceModule,
    'angularUUID2',
  ])
  .directive('addressCreate', AddressCreateDirective).name;
